<template>
  <div>
    <file-uploader :compMode="compMode" entite="Exit"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-sign-out"></i> 
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('project.exit.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('project.exit.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('project.exit.view.title') }}</span>
      </div>
      <div class="card-body">

        <errorMessage v-bind:message="error"></errorMessage>

        <form @keyup.enter="createEntity">
        
          <div class="row">
            <div class="col-md-8">

              <div class="row">

                  <div class="form-group col-md-12">
                      <label for="idInput">{{ $t('project.exit.form.project') }}*</label>
                      
                      <input type="hidden" name="project_validated" v-validate="'required'" v-model="project_validated" />

                      <multiselect v-model="exit.project" id="ajax" open-direction="bottom" 
                          :options="projects" :multiple="false" :searchable="true" :loading="isLoading" 
                          :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                          :options-limit="300" :max-height="600" :show-no-results="true" 
                          :hide-selected="true" :taggable="false" :custom-label="projectLabel"
                          :placeholder="$t('project.exit.form.project')"
                          :select-label="$t('multiselect.select-label')"
                          @search-change="asyncProjectsFind" @select="onSelect">
                          <span slot="noResult">{{ $t('multiselect.not-found')}}.</span>
                      </multiselect>

                      <span class="text-danger" v-if="errors.has('projectId')">{{ errors.first('projectId') }}</span>
                      <span class="text-danger" v-if="errors.has('project_validated')">{{ $t('validations.required') }}</span>
                      
                  </div>
              </div>
            </div>
            <div class="col-md-2">
              <label for="typeInput">{{ $t('project.exit.form.duration') }}</label>
              <div class="duration_value">
                  {{ duration }}
              </div>
            </div>

            <div class="col-md-2">
              <label for="typeInput">{{ $t('project.exit.form.tri') }}</label>
              <div class="tri_value">
                  {{ exit.tri == 0 ? '-' : exit.tri }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  <span>{{ $t('project.exit.form.person.title') }}</span>
                  <div class="float-right"  v-if="compMode != CRUDMODE.READ">
                    <a href="#history" name="history" @click="addPersonDate"><span class="fa fa-plus fa-lg"></span></a>
                  </div>
                </div>
                <div class="card-body">

                  <div class="row" v-for="(date, indexD) in datePerson" :key= "indexD">

                    <div class="form-group col-md-4">
                      
                      <table id="dataTableEntrepreneurCompany" width="100%" cellspacing="0" 
                          class="table table-bordered table-striped dataTable" >
                        <thead>
                            <tr>
                              <th width=150>{{ $t('project.exit.form.person.date') }}</th>
                              <th>{{ $t('project.exit.form.person.reason') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <moment-date-picker v-model="date.date" :required="true"></moment-date-picker>
                              <input type=hidden  :data-vv-name="'date_investment' + indexD" v-validate="'required|verify_date_investment'" v-model="date.date" />
                              <span class="text-danger" v-if="errors.has('date_investment'+ indexD)">{{ $t('project.exit.form.bigger_than_investment_date') }}</span>
                            </td>
                            <td>
                              <select v-model="date.reason" :data-vv-name="'reason' + indexD"
                                  v-validate="'required'" class="form-control" id="categoryInput" :placeholder="$t('project.exit.form.person.reason')">
                                  <option v-for="s in reasons" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                              </select>
                              <span class="text-danger" v-if="errors.has('reason'+ indexD)">{{ $t('validations.required') }}</span>

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="form-group col-md-8">

                      <table id="dataTableEntrepreneurCompany" width="100%" cellspacing="0" 
                          class="table table-bordered table-striped dataTable" >
                      <thead>
                          <tr>
                            <th width="200">{{ $t('project.exit.form.person.typePerson') }}</th>
                            <th >{{ $t('project.exit.form.person.person') }}</th>
                            <th width="150">{{ $t('project.exit.form.person.value') }}</th>
                            <td width="50" v-if="compMode != CRUDMODE.READ" align=center>
                              <a href="#history" name="history" @click="f => addPersonValue(date)"><span class="fa fa-plus fa-lg"></span></a>
                            </td> 
                          </tr>
                        </thead>
                        
                        <tbody>
                          <tr class="odd" v-if="date.exitPerson.length == 0">
                              <td valign="top" colspan="5" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                          </tr>

                          <template v-for="(item, index) in date.exitPerson" v-bind:data-id="item.id"> 
                            <tr>
                              <td>
                                  <select class="form-control" v-model="item.type">
                                      <option value=1>{{ $t('project.exit.form.person.partner') }}</option>
                                      <option value=2>{{ $t('project.exit.form.person.member') }}</option>
                                      <option value=3>{{ $t('project.exit.form.person.autre') }}</option>
                                  </select>
                              </td>
                              <td v-if="item.type == 1">
                                <multiselect v-model="item.partner" id="ajax" :custom-label="partnerLabel" 
                                  track-by="id" :placeholder="$t('project.investment.form.history.partner')" open-direction="bottom" 
                                  :options="partners" :multiple="false" :searchable="true" :loading="isLoading" 
                                  :internal-search="true" :clear-on-select="true" :close-on-select="true" 
                                  :options-limit="300" :max-height="600" :show-no-results="true" 
                                  :hide-selected="true" :select-label="$t('multiselect.select-label')">

                                  <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
                                </multiselect>
                              </td>
                              
                              <td v-if="item.type == 2">
                                
                                <multiselect v-model="item.member" id="ajax" :custom-label="memberLabel" 
                                  track-by="id" :placeholder="$t('project.investment.form.history.member')" open-direction="bottom" 
                                  :options="members" :multiple="false" :searchable="true" :loading="isLoading" 
                                  :internal-search="true" :clear-on-select="true" :close-on-select="true" 
                                  :options-limit="300" :max-height="600" :show-no-results="true" 
                                  :hide-selected="true" :select-label="$t('multiselect.select-label')">

                                  <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
                                </multiselect>

                              </td>

                              <td v-if="item.type == undefined || item.type == 3">
                                &nbsp;
                              </td>

                              <td>
                                  <input v-model.trim="item.value" v-money="{}" name="value" 
                                    type="text" class="form-control" id="value"  />
                              </td>

                              <td align=center >
                                <a v-if="compMode != CRUDMODE.READ" class="text-danger" v-bind:title="$t('form.delete_button')" href="#InvestmentValue" v-on:click="removePersonValue(date, index)">
                                    <span class="fa fa-lg fa-trash"></span>
                                </a>
                              </td> 
                            </tr>
                          </template>
                        </tbody>
                      </table>
                  
                    </div>
                  </div>

                  <div v-if="datePerson == undefined || datePerson.length == 0">
                    {{ $t('form.aucun_donne') }}
                  </div>

                </div>
              </div>
            </div>
          </div>

          <a @click="createEntity" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
            {{ $t('form.create_button') }}
          </a>

          <a @click="editEntity" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
            {{ $t('form.edit_button') }}
          </a>

        </form>
      </div>

    </div>

    <investmentSummary :entites="investments" :visible="false"></investmentSummary>
    
  </div>
</template>


<script>
import {
  ExitServiceClient,
  CompanyServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  ProjectDto,
  EntrepriseDto,
  CompanyExitDto,
  ExitDto,
  ExitPersonDto,
  InvestmentDto,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import FinanceMixin from '../../shared/Mixin/FinanceMixin'
import Enum from '../../shared/enum'
import ErrorMessage from '../ErrorMessage.vue'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import InvestmentSummary from './InvestmentSummary'

import Multiselect from 'vue-multiselect'
import moment from 'moment'
import VeeValidate, {Validator} from 'vee-validate'

export default {
  name: 'CreateExit',
  mixins: [CrudMixin, FinanceMixin],
  data() {
    let dto = new ExitDto()
    dto.project = new ProjectDto()
    dto.project.entreprise = new EntrepriseDto()
    dto.date = moment()
    dto.exitPerson = []
    dto.tri = 0

    let investment = new InvestmentDto()
    investment.init({})

    return {
      reasons: [],
      types: [],
      projects: [],
      isLoading: false,
      exit: dto,
      members: [],
      partners: [],
      investments: [],
      datePerson: [],
      tri: {},
    }
  },
  mounted: function() {
    let self = this
    setTimeout(function() {
      self.fetchData()
      self.setMode()
    }, 1000)
  },
  created() {
    VeeValidate.Validator.extend('verify_date_investment', {
      getMessage: field => 'bigger_than_investment_date',
      validate: value => {
        return moment(value).isSameOrAfter(this.first_investment_date)
      },
    })
  },
  computed: {
    tri_value: function() {
      if (this.investments != null && this.investments.length > 0) {
        let localValue = _.clone(this.datePerson, true)
        let investments = this.getDateValueFromInvestments(this.investments)

        // ça arrive quand on n'ai pas de deboursement dans l'investissement... fait que pas de calcul
        if (investments.length > 0) {
          let exits = this.getDateValueFromExit(localValue)
          let ensemble = this.mergeInvestmentAndExits(investments, exits)

          if (ensemble != null) {
            this.exit.tri = this.mergeValuesWithAllPossibleDates(ensemble)
          }
        }
      }
    },
    project_validated: function() {
      if (this.exit.project != null) return this.exit.project.id
      else return null
    },
    exitType_validate: function() {
      return this.exit.exitType
    },
    exitReason_validate: function() {
      return this.exit.reason
    },
    first_investment_date: function() {
      if (this.investments == null || this.investments.length == 0) return null

      let minDate = _.chain(this.investments)
        .flatMap(f => f.investmentValues)
        .flatMap(f => f.disbursements)
        .map(exits => {
          return {
            date: exits != null ? exits.date : null,
          }
        })
        .minBy('date')
        .value()

      if (minDate != null) return minDate.date

      return null
    },
    duration: function() {
      if (this.first_investment_date == null || this.datePerson == null || this.datePerson.length == 0) return 0

      let dateDerniereSortie = _.maxBy(this.datePerson, x => moment(x.date))

      this.exit.duration = moment(dateDerniereSortie.date).diff(this.first_investment_date, 'years')

      return this.exit.duration
    },
  },
  methods: {
    mergeValuesWithAllPossibleDates: function(ensemble) {
      if (ensemble != null) {
        let minDate = _.minBy(ensemble, m => {
          return new Date(m.date)
        })
        let maxDate = _.maxBy(ensemble, m => {
          return new Date(m.date)
        })

        if (minDate != undefined && maxDate != undefined) {
          let arrayOfDates = this.getArrayOfDate(minDate.date, maxDate.date)

          let values = _.chain(arrayOfDates)
            .concat(ensemble)
            .groupBy('date')
            .map((concat, date) =>
              _.sumBy(concat, s => {
                return parseInt(s.value)
              })
            )
            .orderBy(o => moment(o.date))
            .value()

          // for debug purposes
          this.tri = values

          let triLocal = this.IRR(values)
          return triLocal === undefined ? 0 : triLocal
        }
      }
    },
    mergeInvestmentAndExits: function(investments, exits) {
      return _.chain(exits)
        .concat(investments)
        .groupBy('date')
        .map((concat, date) => {
          return {
            date: date,
            value: _.sumBy(concat, s => {
              return parseInt(s.value)
            }),
          }
        })
        .orderBy(o => moment(o.date))
        .value()
    },
    getDateValueFromExit: function(value) {
      return _.chain(value)
        .groupBy(g => {
          return moment(g.date).startOf('month')
        })
        .map((exits, date) => {
          var flat = _.flatMap(exits, item => {
            return _.map(item.exitPerson, function(person) {
              return parseInt(person.value)
            })
          })
          return {
            date: date,
            value: _.sum(flat),
          }
        })
        .value()
    },
    getDateValueFromInvestments: function(investments) {
      return _.chain(investments)
        .flatMap(f => f.investmentValues)
        .flatMap(f => f.disbursements)
        .groupBy(g => {
          return moment(g.date).startOf('month')
        })
        .map((exits, date) => {
          return {
            date: date,
            value: _.sumBy(exits, s => {
              return parseInt(s.value) * -1
            }),
          }
        })
        .value()
    },
    getArrayOfDate: function(start, end) {
      let startDate = moment(start)
      let endDate = moment(end)

      var result = []

      if (endDate.isBefore(startDate)) {
        throw 'End date must be greated than start date.'
      }

      while (!startDate.isAfter(endDate)) {
        result.push({date: startDate.clone(), value: 0})
        startDate = startDate.add(1, 'month')
      }

      return result
    },
    addPersonDate: function() {
      this.datePerson.push({
        date: Date(),
        reason: undefined,
        exitPerson: [],
      })
    },
    addPersonValue: function(date) {
      let dto = new ExitPersonDto()
      dto.init({})
      date.exitPerson.push(dto)
    },
    removePersonValue: function(date, index) {
      date.exitPerson.splice(index, 1)
    },
    manageEntity: function() {
      let cleanEntity = this.cleanFields(this.exit)

      cleanEntity.project = ProjectDto.fromJS(cleanEntity.project)

      cleanEntity.exitPerson = _.flatMap(this.datePerson, item => {
        return _.map(item.exitPerson, function(person) {
          let data = {
            date: item.date,
            reason: item.reason,
            partnerId: person.partner != null ? person.partner.id : undefined,
            memberId: person.member != null ? person.member.id : undefined,
            id: person.id,
            value: person.value,
            exitId: person.exitId,
          }
          let dto = new ExitPersonDto()
          dto.init(data)

          return dto
        })
      })

      return cleanEntity
    },
    createEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && self.ready) {
            let entityService = ServiceFactory.create(ExitServiceClient)

            entityService
              .create(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                this.$swal('Succès', this.$t('project.exit.create.succes'), 'success')
                this.$router.push({path: '/projects/exits'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log('error: ' + self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && this.ready) {
            let entityService = ServiceFactory.create(ExitServiceClient)

            entityService
              .update(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                self.$swal('Succès', this.$t('project.exit.edit.succes'), 'success')
                self.$router.push({path: '/projects/exits'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    fetchData: function() {
      let service = ServiceFactory.create(ExitServiceClient)
      let EntityService = ServiceFactory.create(ExitServiceClient)

      let getReasons = service.getReasons()

      let self = this
      let promisseAll

      getReasons
        .then(res => {
          self.reasons = res
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let getEntity = EntityService.get(this.$route.params.id)
        getEntity
          .then(res => {
            self.exit = res

            self.chargeInvestments(self.exit.projectId)
            self.chargeDatePerson(self.exit)
          })
          .catch(err => {
            console.log(err)
          })
        promisseAll = Promise.all([getReasons, getEntity])
      } else {
        promisseAll = Promise.all([getReasons])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
    chargeDatePerson: function(exit) {
      let transformObj = _(exit.exitPerson)
        .map(m => _.defaults({type: m.partnerId != null ? 1 : m.memberId != null ? 2 : 3}, m))
        .groupBy(x => x.date)
        .map((value, key) => ({date: key, reason: value[0].reason, exitPerson: value}))
        .value()

      this.datePerson = transformObj
    },
    chargeInvestments: function(id) {
      let InvestmentService = ServiceFactory.create(InvestmentServiceClient)
      let self = this

      InvestmentService.getAll(id, undefined, '', 0, 10000)
        .then(res => {
          self.investments = res.items

          let flattened = _(res.items).flatMap(f => f.investmentValues)
          self.partners = flattened
            .filter(f => f.partner != null)
            .flatMap(f => f.partner)
            .uniqBy('id')
            .value()
          self.members = flattened
            .filter(f => f.member != null)
            .flatMap(f => f.member)
            .uniqBy('id')
            .value()
        })
        .catch(err => {
          console.log(err)
        })
    },
    asyncProjectsFind: function(search) {
      this.isLoading = true
      let self = this
      let service

      service = ServiceFactory.create(ProjectServiceClient)
      service.getAutocomplete(undefined, 1, search).then(response => {
        self.projects = response
        self.isLoading = false
      })
    },
    onSelect: function(item) {
      this.$emit('projectSelected', item)
      this.exit.project = item
      this.exit.projectId = item.id

      this.chargeInvestments(item.id)
    },
    projectLabel: function(project) {
      return project.entreprise.name
    },
    partnerLabel: function(obj) {
      return obj.name
    },
    memberLabel: function(obj) {
      return obj.familyName + ', ' + obj.name
    },
  },
  components: {
    errorMessage: ErrorMessage,
    Multiselect,
    'moment-date-picker': MomentDatePicker,
    InvestmentSummary,
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}

.tri_value, .duration_value{
  position: relative;
  font-size: 25px;
  font-weight: bold;
  border-bottom: 1px solid #e9ecef;
}
.tri_value::after{
  content: " %"
}
</style>



// WEBPACK FOOTER //
// src/components/Investment/CreateExit.vue